import React, {Component} from 'react'
import moment from "moment";

const UserRoleHistoryListItem = ({user_role, active_from}) => {
    return (
        <div className="d-flex flex-row align-items-center justify-content-between border-bottom pt-2 pb-2">
            <div className="d-flex flex-column">
                <p className="font-weight-light p-0 m-0">
                    {user_role.description}
                </p>
                <small>
                    Active From: {moment(active_from).format('DD/MM/YYYY')}
                </small>
            </div>
        </div>
    )
}

export default UserRoleHistoryListItem